import { i18n } from 'i18n';
import {
  makeCreateMutation,
  makeDeleteMutation,
  makeGetQuery,
  makeUpdateMutation
} from './useApi';
import {
  QaqcSampleDto,
  QaqcSampleForm
} from './api';

export const QAQC_SAMPLES_KEY = 'qaqc-samples';
export const QAQC_SAMPLE_KEY = 'qaqc-sample';

export const useQaqcSamplesForPourQuery = makeGetQuery<QaqcSampleDto[], string>(
  QAQC_SAMPLES_KEY,
  (api, pourId) => () => api.qaqcSamples.listByPour(pourId),
);

export const useGetQaqcSampleQuery = makeGetQuery<QaqcSampleDto, string>(
  QAQC_SAMPLE_KEY,
  (api, qaqcSampleId) => () => api.qaqcSamples.get(qaqcSampleId),
);

export interface QaqcSampleMutation {
  pourId?: string;
  form: QaqcSampleForm;
}

export const useCreateQaqcSampleMutation = makeCreateMutation<string, QaqcSampleMutation>(
  QAQC_SAMPLES_KEY,
  (api) => (mutation) => api.qaqcSamples.create(mutation.pourId ?? '', mutation.form),
  () => i18n._('QAQC sample saved'),
  [QAQC_SAMPLE_KEY],
);

export const useUpdateQaqcSampleMutation = makeUpdateMutation<void, QaqcSampleMutation>(
  QAQC_SAMPLE_KEY,
  QAQC_SAMPLES_KEY,
  (api, qaqcSampleId) => (mutation) => api.qaqcSamples.update(qaqcSampleId, mutation.form),
  () => i18n._('QAQC sample updated'),
);

export const useDeleteQaqcSampleMutation = makeDeleteMutation<void, string>(
  QAQC_SAMPLE_KEY,
  QAQC_SAMPLES_KEY,
  (api) => (qaqcSampleId) => api.qaqcSamples.delete(qaqcSampleId),
  () => i18n._('QAQC sample deleted'),
  (qaqcSampleId) => qaqcSampleId,
);
